module.exports = __webpack_public_path__ + "static/media/6.c34be696.jpg";